import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { DonorModule } from '../donor/donor.module';
import { FrCardModule } from '../fr-card/fr-card.module';
import { InputModule } from '../input/input.module';
import { CommentCardComponent } from './components/comment-card/comment-card.component';
import { InViewportModule } from 'ng-in-viewport';
import { SharedModule } from '../../shared/shared.module';
import { ModuleLoaderModule } from '../module-loader/module-loader.module';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    ReactiveFormsModule,
    FrCardModule,
    DonorModule,
    InViewportModule,
    InputModule,
    ModuleLoaderModule,
    MatCardModule,
    MatIconModule,
    MatButtonModule
  ],
  declarations: [
    CommentCardComponent,
  ],
  exports: [CommentCardComponent],
  bootstrap: [CommentCardComponent]
})
export class CommentCardModule {
  getComponent() {
    return CommentCardComponent;
  }
}
